import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Accordions from './accordions';
import { scrollOnClick, selectOnScroll } from './Functions/scroll';
import { MenuCategoryContext } from './menu';

const Category = ({ menu, collapse }) => {
  const { categoryId, setCategoryId, eventType, setEventType } = useContext(MenuCategoryContext);
  const restaurantStatus = useSelector((state) => state.restSetting?.Setting?.status);
  window.onscroll = selectOnScroll('mainMenuContainer', eventType, setCategoryId);

  useEffect(() => {
    scrollOnClick(`uniquiMenuId${categoryId}`, eventType, setEventType);
  }, [categoryId]);

  return (
    <div
      style={{ minHeight: '70vh' }}
      id='mainMenuContainer'
      className={`d-flex flex-column gap-2 safe-bottom-margin-full ${
        restaurantStatus == 2 ? 'disabled-menu' : ''
      }`}>
      {menu?.map(({ name, items }, index) => {
        return (
          <div key={index} id={`uniquiMenuId${index}`} className='menuCategories '>
            {items.length > 0 && (
              <div name={name}>
                <div
                  style={{ textTransform: 'lowercase' }}
                  className='fs-18 fw-800 category-heading text-capitalize appSubHeader '>
                  {String(name).toLowerCase()}
                </div>
                <Accordions body={items} collapse={collapse} menuCard />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Category;
